import React from 'react';
import type { DashboardAggregates } from '../../types/machinesDashboard';

export default function VendorBreakdownWidget({ data }: { data: DashboardAggregates }) {
  return (
    <div className="vendor-breakdown-card h-100">
      <div className="dashboard-card-header-modern d-flex align-items-center gap-2">
        <i className="bi bi-diagram-3 fs-5 dashboard-gradient-text" />
        <span className="fw-semibold">Macchine per vendor</span>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-sm align-middle mb-0 dashboard-table-modern">
            <thead>
              <tr>
                <th>Vendor</th>
                <th className="text-end">Tot</th>
                <th className="text-end">Online</th>
                <th className="text-end">Offline</th>
              </tr>
            </thead>
            <tbody>
              {data.vendors.map((v) => (
                <tr key={String(v.provider)} className="vendor-breakdown-item">
                  <td className="fw-semibold">{String(v.provider)}</td>
                  <td className="text-end fw-semibold">{v.total}</td>
                  <td className="text-end">
                    <span className="badge text-bg-success">{v.online}</span>
                  </td>
                  <td className="text-end">
                    <span className="badge text-bg-warning">{v.offline}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}